import { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";

import useAxios from "../services/useAxios";

import UseFullDataContext from "../context/UseFullData";

import { PlusIcon } from "../components/kits/Icons";
import CustomButton from "../components/kits/button/CustomButton";
import ColorSchema from "../components/kits/Color";
import ToastCustomize from "../components/kits/ToastCustomize";

import { swalFunc } from "../utils/helperFunction";

import ProductPageIndex from "../components/product-list-page";
import Loader from "../utils/Loader";

import "../components/product-list-page/product-list-style.scss";
export default function ProductListPage() {
  const { productTypeList, priceType } = useContext(UseFullDataContext);

  const [productListData, setProductListData] = useState([]);
  const [productUpdater, setProductUpdater] = useState(false);
  const [productListTotal, setProductListTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const { execute: productListApi } = useAxios("product/get_products");
  const { execute: deactivate } = useAxios("api/Update_products");

  const productListFunc = (object, page = 1) => {
    let temp = [];
    let price = 0;
    let priceTypeValue = "";
    let discount = 0;
    let discountType = "";

    productListApi({ ...object, page: page, count: 10 }).then((result) => {
      temp = result?.result?.map((value) => {
        priceTypeValue =
          priceType.filter((v) => v.value == value?.benefit_type)[0]?.label ??
          "-";
        discountType =
          priceType.filter((v) => v.value == value?.discount_type)[0]?.label ??
          "-";
        discount = value?.discount ?? 0;
        switch (value.type) {
          case "1":
            price = value?.benefit_value;
            break;
          case "2":
            price = value?.base_price;
            break;
          case "3":
            price = value?.base_price;
            break;
          default:
            price = 0;
            break;
        }
        return {
          title: value?.title ?? "",
          description: value?.description ?? "",
          type: productTypeList.filter((v) => v?.value == value?.type)[0] ?? {},
          price: price,
          priceType: priceTypeValue ?? "-",
          image: value?.cover ?? "",
          discount: discount,
          id: value.id,
          status: value.status ?? 0,
        };
      });
      let tempSort = temp.reverse().sort((a, b) => {
        return b.status - a.status;
      });
      setProductListData(tempSort);
      setProductListTotal(result?.total);
      setLoading(false);
    });
  };
  const deactivateProduct = (id, status) => {
    swalFunc(
      status == -1
        ? `آیا از غیرفعال کردن محصول مطمئن هستید؟`
        : "آیا از فعال کردن محصول مطمئن هستید؟",
      () =>
        deactivate({
          conditions: `id/=/${id}`,
          keyvalues: `status,${status}`,
        }).then((res) => {
          if (res.status == 1) {
            ToastCustomize({
              mainText: "محصول با موفقیت غیرفعال شد.",
              duration: 3000,
              toastType: "success",
              color: "success",
              position: "top-center",
              hasHeader: false,
            });
            setProductUpdater((prev) => !prev);
          } else
            ToastCustomize({
              mainText: "مشکلی  پیش آماده است",
              duration: 3000,
              toastType: "danger",
              color: "danger",
              position: "top-center",
              hasHeader: false,
            });
        }),
      "warning"
    );
  };
  useEffect(() => {
    setLoading(true);
    productListFunc();
  }, [productTypeList, productUpdater]);
  return loading ? (
    <Loader />
  ) : (
    <div className="new-product-page mx-auto">
      <NavLink
        to={"/new-single-product/create"}
        className={"text-decoration-none"}
      >
        <CustomButton className="" color="primary">
          <PlusIcon color={ColorSchema.white_custom} />
          افزودن
        </CustomButton>
      </NavLink>

      <ProductPageIndex
        data={productListData}
        setProductUpdater={setProductUpdater}
        deactivateProduct={deactivateProduct}
        productListTotal={productListTotal}
        productListFunc={productListFunc}
      />
    </div>
  );
}
